// frontend/src/components/games/snake/snakeConstants.ts
//
// Snake oyununa özel sabitler. Memory Game ile hiçbir dosya paylaşılmaz.

export const GRID_SIZE = 16;
export const BASE_TICK_MS = 160; // normal hızda bir hareketin süresi

export const FRUIT_EMOJIS = ['🍎', '🍌', '🍓', '🍇', '🍒', '🍉', '🥝', '🍍', '🫐', '🍑'];
export const FRUIT_SCORE = 10;

export type SpecialItemType = 'double-score' | 'speed-boost' | 'slow-motion' | 'extra-life' | 'shield';

export interface SpecialItemConfig {
  type: SpecialItemType;
  emoji: string;
  label: string;
  /** Etkinin süresi (ms). Anlık etkiler (extra-life, shield) için 0. */
  durationMs: number;
}

export const SPECIAL_ITEMS: SpecialItemConfig[] = [
  { type: 'double-score', emoji: '⭐', label: '2x Skor', durationMs: 10_000 },
  { type: 'speed-boost', emoji: '⚡', label: 'Hız Artışı', durationMs: 8_000 },
  { type: 'slow-motion', emoji: '🐢', label: 'Yavaşlama', durationMs: 8_000 },
  { type: 'extra-life', emoji: '❤️', label: 'Ekstra Can', durationMs: 0 },
  { type: 'shield', emoji: '🛡', label: 'Kalkan', durationMs: 0 },
];

/** Her tick'te (oyun döngüsü adımı) özel eşya doğma olasılığı — nadir olması için düşük tutulur. */
export const SPECIAL_ITEM_SPAWN_CHANCE = 0.012;
/** Doğan bir özel eşyanın, toplanmazsa kaç ms sonra kaybolacağı. */
export const SPECIAL_ITEM_LIFETIME_MS = 7_000;

export const SPEED_BOOST_MULTIPLIER = 0.55; // daha düşük ms = daha hızlı
export const SLOW_MOTION_MULTIPLIER = 1.7;
